var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 640",
    fill: "none",
    role: "img",
    "aria-label": "Tampilan halaman verifikasi LOA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 640,
    rx: 12,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 72,
    fill: "#4569ab"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#FFFFFF",
    opacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 200,
    height: 8,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 96,
    width: 496,
    height: 528,
    rx: 8,
    fill: "#F4F4F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 112,
    width: 464,
    height: 496,
    rx: 8,
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 148,
    r: 22,
    fill: "#16a34a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272 148l6 6 12-13",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 178,
    width: 64,
    height: 10,
    rx: 4,
    fill: "#16a34a",
    opacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 172,
    width: 280,
    height: 14,
    rx: 4,
    fill: "#171A20",
    opacity: 0.85
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 208,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 204,
    width: 180,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 236,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 232,
    width: 240,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 248,
    width: 200,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 276,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 272,
    width: 220,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 308,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 304,
    width: 320,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 280,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 348,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 344,
    width: 120,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 380,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 376,
    width: 48,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 412,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 408,
    width: 32,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 444,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 440,
    width: 88,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 476,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 472,
    width: 56,
    height: 10,
    rx: 4,
    fill: "#171A20",
    opacity: 0.15
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 508,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#5C5E62",
    opacity: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 504,
    width: 300,
    height: 10,
    rx: 4,
    fill: "#4569ab",
    opacity: 0.35
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 224,
    x2: 512,
    y2: 224,
    stroke: "#EEEEEE"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 264,
    x2: 512,
    y2: 264,
    stroke: "#EEEEEE"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 296,
    x2: 512,
    y2: 296,
    stroke: "#EEEEEE"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 336,
    x2: 512,
    y2: 336,
    stroke: "#EEEEEE"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 368,
    x2: 512,
    y2: 368,
    stroke: "#EEEEEE"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 400,
    x2: 512,
    y2: 400,
    stroke: "#EEEEEE"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 432,
    x2: 512,
    y2: 432,
    stroke: "#EEEEEE"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 464,
    x2: 512,
    y2: 464,
    stroke: "#EEEEEE"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 496,
    x2: 512,
    y2: 496,
    stroke: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyPreview);
export default __webpack_public_path__ + "static/media/verify-preview.f466b2f3ee0aaa2f7aaae7cd3818b978.svg";
export { ForwardRef as ReactComponent };